global.conmed = global.conmed || {};

conmed.iframeBlock = function ($) {

    'use strict';

    var that = {

        selectors: {
            section: '.iframe-block',
            loading: '.loading',
            iframe: '.frame'
        }
    };

    that.init = function () {

        $(that.selectors.iframe).on("load", function () {
            setTimeout(function () {
                $(that.selectors.loading).css("display", "none");
                $(that.selectors.iframe).css("opacity", 1);
            }, 3000);
        });
    };

    return that;
}(jQuery);